<template>
  <div id="app">
    <div v-show="!(path === '/examination')" class="head">
      <div class="logo"></div>
      <div class="goindex el-icon-s-home" @click="gotoIndex"></div>
      <div class="head_search">
        <el-input
          @keyup.enter.native="searchTrain()"
          size="mini"
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="keyWord">
        </el-input>
      </div>
    </div>
    <div class="indexContent">
      <router-view ref="view"></router-view>
      <!-- <index></index> -->
    </div>
    <div v-show="!(path === '/examination')" class="bottom">
      版权所有: 福建省海运集团中平船舶管理有限公司
      <div style="position:relative;margin: 15px 10px;font-size: 13px">V {{ getVersion }}</div>
    </div>
    <div v-show="!(path === '/examination')" class="bottom2">
    </div>
    <el-button @click="exportTimeList" class="exportTime">导出学时证明</el-button>
    <certificate></certificate>
  </div>
</template>

<script>
// import index from '@/page/index'
import * as req from '@/utils/request'
import certificate from '@/page/certificate'
export default {
  name: 'App',
  data () {
    return {
      keyWord: '',
      path: '',
      viewed: 0,
      // 服务器未连接次数 超过三层退出界面
      serverUnconnectCount: 0
    }
  },
  computed: {
    getVersion () {
      return window.$global.version
    }
  },
  mounted () {
    this.path = this.$route.path
  },
  created () {
    this.getToken()
    this.getBranchList()
    this.getStationList()
    setInterval(() => {
      this.serverUnconnectCount = 0
    }, 40000)
  },
  watch: {
    $route (to, from) {
      this.path = to.path
      if (to.path === '/index/menuIndex') {
        this.getbooksRead(this.global.user_info.id)
      }
    },
    serverUnconnectCount (newVal, oldVal) {
      if (newVal >= 3) {
        window.location.href = window.$global.loginURL
        this.serverUnconnectCount = 0
      }
    }
  },
  methods: {
    exportTimeList () {
      let id = this.global.user_info.id
      let sendData = {}
      sendData.data = {
        id: id
      }
      sendData.fn = this.exportTimeListFn
      sendData.vm = this
      req.Post('certificate/get', sendData)
    },
    exportTimeListFn (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      this.global.exportList = data.data
      this.global.dialogVisible = true
    },
    exportTime () {
      if (!this.global.user_info) {
        return
      }
      let id = this.global.user_info.id
      let sendData = {}
      sendData.data = {
        id: id
      }
      sendData.fn = this.exportTimeFn
      sendData.vm = this
      req.Post('online_duration/get_month', sendData)
    },
    exportTimeFn (data) {
      if (!data) {
        this.$message.error('您的学时为' + 0 + '学时,不符合导出条件')
        return
      }
      if (!data.total) {
        this.$message.error('您的学时为' + 0 + '学时,不符合导出条件')
        return
      }
      // 判断学时是否符合
      this.checkTime(data.total)
    },
    checkTime (total) {
      // 转化为小时
      let hour = total / 3600
      let stationId = this.global.user_info.station_id
      let stationTime = 0
      // 如果station_id是1，2，3，4 学时标准为24小时 其余为20小时
      if (stationId === 1 || stationId === 2 || stationId === 3 || stationId === 4) {
        stationTime = 24
      } else {
        stationTime = 20
      }
      if (hour < stationTime) {
        this.$message.error('您的学时为' + hour.toFixed(2) + '学时,不符合导出条件,标准为' + stationTime + '学时')
        return
      }

      // this.exportOnlineTime(stationTime)
      // this.exportOnlineTimeWord(stationTime)
      this.exportOnlineTimePng(stationTime)
      // this.exportOnlineTimePDF(hour)
    },
    // 导出在线学时 文件
    exportOnlineTime (hour) {
      // 获取用户信息
      const userInfo = this.global.user_info
      if (!userInfo) {
        this.$message.error('请先登录')
        return
      }

      // 获取当前日期
      const now = new Date()
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}年${month}月${day}日`
      }

      // 计算开始日期（假设培训周期为一个月）
      const startDate = new Date(now)
      startDate.setMonth(startDate.getMonth() - 1)

      // 构建学时证明内容
      const proofContent = `
      学时证明

      ${userInfo.name || '学员'}：
      于 ${formatDate(startDate)}——${formatDate(now)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，
      完成${hour}学时（60分钟/学时），符合要求。

                          福建省海运集团中平船舶管理有限公司
                              ${formatDate(now)}
        `

      // 创建Blob对象
      const blob = new Blob([proofContent], { type: 'text/plain;charset=utf-8' })

      // 创建下载链接
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `学时证明_${userInfo.name || '学员'}_${formatDate(now)}.txt`

      // 执行下载
      link.click()

      // 清理资源
      setTimeout(() => {
        URL.revokeObjectURL(link.href)
      }, 100)
      this.$message.success('学时证明导出成功')
    },
    async exportOnlineTimeWord (hour) {
      try {
        // 动态导入docx库，包括AlignmentType
        const { Document, Paragraph, TextRun, HeadingLevel, Packer, AlignmentType } = await import('docx')

        // 获取用户信息
        const userInfo = this.global.user_info
        if (!userInfo) {
          this.$message.error('请先登录')
          return
        }

        // 获取当前日期
        const now = new Date()
        const formatDate = (date) => {
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}年${month}月${day}日`
        }

        // 计算开始日期（假设培训周期为一个月）
        const startDate = new Date(now)
        startDate.setMonth(startDate.getMonth() - 1)

        // 创建Word文档
        const doc = new Document({
          sections: [{
            properties: {
              page: {
                margin: {
                  top: 1720, // 页边距，720缇=0.5英寸=12.7mm
                  bottom: 1720,
                  left: 2220,
                  right: 2220
                }
              }
            },
            children: [
              // 标题 - 居中对齐
              new Paragraph({
                heading: HeadingLevel.HEADING_1,
                alignment: AlignmentType.CENTER, // 居中对齐
                children: [
                  new TextRun({
                    text: '学时证明',
                    bold: true,
                    size: 45, // 字号
                    font: 'SimSun', // 字体
                    color: '000000' // 黑色字体
                  })
                ]
              }),

              // 空行
              new Paragraph({
                spacing: { before: 200 }
              }),

              // 学员姓名 - 左对齐
              new Paragraph({
                alignment: AlignmentType.LEFT, // 左对齐
                children: [
                  new TextRun({
                    text: `${userInfo.name || '学员'}：`,
                    size: 32, // 字号
                    font: 'SimSun'
                  })
                ]
              }),

              // 培训详情 - 左对齐
              new Paragraph({
                alignment: AlignmentType.LEFT, // 左对齐
                children: [
                  new TextRun({
                    text: `  于 ${formatDate(startDate)}——${formatDate(now)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，完成${hour}学时（60分钟/学时），符合要求。`,
                    size: 32, // 字号
                    font: 'SimSun'
                  })
                ]
              }),

              // 空行
              new Paragraph({
                spacing: { before: 400 }
              }),

              // 公司名称 - 居中偏右对齐
              new Paragraph({
                alignment: AlignmentType.RIGHT, // 左对齐
                children: [
                  new TextRun({
                    text: '福建省海运集团中平船舶管理有限公司',
                    size: 32, // 字号
                    font: 'SimSun'
                  })
                ]
              }),

              // 日期 - 右对齐
              new Paragraph({
                alignment: AlignmentType.RIGHT, // 右对齐
                indent: { right: 200 },
                children: [
                  new TextRun({
                    text: formatDate(now),
                    size: 32, // 字号
                    font: 'SimSun'
                  })
                ]
              })
            ]
          }]
        })

        // 生成并下载Word文档
        const blob = await Packer.toBlob(doc)

        // 创建下载链接
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `学时证明_${userInfo.name || '学员'}_${formatDate(now)}.docx`

        // 执行下载
        link.click()

        // 清理资源
        setTimeout(() => {
          URL.revokeObjectURL(link.href)
        }, 100)

        this.$message.success('Word学时证明导出成功')
      } catch (error) {
        console.error('Word文档导出失败:', error)
        this.$message.error('Word文档导出失败，请重试')
      }
    },
    async exportOnlineTimePng2 (hour) {
      // 获取用户信息
      const userInfo = this.global.user_info
      if (!userInfo) {
        this.$message.error('请先登录')
        return
      }

      // 获取当前日期
      const now = new Date()
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}年${month}月${day}日`
      }

      // 计算开始日期（假设培训周期为一个月）
      const startDate = new Date(now)
      startDate.setMonth(startDate.getMonth() - 1)

      // 创建canvas元素
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      // 设置画布尺寸
      canvas.width = 800
      canvas.height = 1000

      // 设置背景色
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // 设置字体
      ctx.font = 'bold 36px SimSun, SimHei, Arial, sans-serif'
      ctx.fillStyle = '#000000'
      ctx.textAlign = 'center'

      // 绘制标题
      const title = '学时证明'
      ctx.fillText(title, canvas.width / 2, 80)

      // 设置正文字体
      ctx.font = '24px SimSun, SimHei, Arial, sans-serif'
      ctx.textAlign = 'left'

      // 绘制学员姓名
      const userName = `${userInfo.name || '学员'}：`
      ctx.fillText(userName, 80, 150)

      // 绘制培训详情
      const trainDetails = `于 ${formatDate(startDate)}——${formatDate(now)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，完成${hour}学时（60分钟/学时），符合要求。`
      this.wrapText(ctx, trainDetails, 100, 200, canvas.width - 160, 30) // 缩进20px

      // 绘制公司名称
      ctx.textAlign = 'right' // 右对齐
      const company = '福建省海运集团中平船舶管理有限公司'
      ctx.fillText(company, canvas.width - 80, 600)

      // 绘制日期
      const date = formatDate(now)
      ctx.fillText(date, canvas.width - 80, 650)

      // 转换为PNG并下载
      const pngUrl = canvas.toDataURL('image/png')

      // 创建下载链接
      const link = document.createElement('a')
      link.href = pngUrl
      link.download = `学时证明_${userInfo.name || '学员'}_${formatDate(now)}.png`

      // 执行下载
      link.click()

      this.$message.success('PNG学时证明导出成功')
    },

    // 辅助函数：文本自动换行
    wrapText (context, text, x, y, maxWidth, lineHeight) {
      const words = text.split('')
      let line = ''
      let currentY = y

      for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n]
        const metrics = context.measureText(testLine)
        const testWidth = metrics.width

        if (testWidth > maxWidth && n > 0) {
          context.fillText(line, x, currentY)
          line = words[n]
          currentY += lineHeight
        } else {
          line = testLine
        }
      }
      context.fillText(line, x, currentY)
    },
    async exportOnlineTimePng (hour) {
      // 获取用户信息
      const userInfo = this.global.user_info
      if (!userInfo) {
        this.$message.error('请先登录')
        return
      }

      // 获取当前日期
      const now = new Date()
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}年${month}月${day}日`
      }

      // 计算开始日期（假设培训周期为一个月）
      const startDate = new Date(now)
      startDate.setMonth(startDate.getMonth() - 1)

      // 创建canvas元素
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      // 设置画布尺寸
      canvas.width = 1080
      canvas.height = 764

      try {
        // 加载背景图片
        const backgroundImage = new Image()
        // 使用项目中的logo图片作为背景
        backgroundImage.src = require('@/assets/backBook.jpg')

        // 等待背景图片加载完成
        await new Promise((resolve, reject) => {
          backgroundImage.onload = () => resolve()
          backgroundImage.onerror = () => {
            // 如果背景图片加载失败，继续执行而不使用背景
            console.warn('背景图片加载失败，使用纯白背景')
            resolve()
          }
        })

        // 绘制背景图片，如果没有背景图片则保持白色背景
        if (backgroundImage.complete && backgroundImage.naturalWidth !== 0) {
          // 绘制背景图片，覆盖整个画布并设置透明度
          ctx.globalAlpha = 1 // 设置透明度为10%
          ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height)
          ctx.globalAlpha = 1.0 // 恢复透明度
        } else {
          // 如果没有背景图片，绘制白色背景
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
        }

        // 设置正文字体
        ctx.font = '20px SimSun, SimHei, Arial, sans-serif'
        ctx.fillStyle = '#000000' // 黑色
        ctx.textAlign = 'left'

        // 绘制学员姓名
        const userName = `${userInfo.name || '学员'}`
        ctx.fillText(userName, 120, 300)

        // 绘制培训详情
        const trainDetails = `  于 ${formatDate(startDate)}——${formatDate(now)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，完成${hour}学时（60分钟/学时），符合要求。`
        this.wrapText(ctx, trainDetails, 120, 350, canvas.width - 240, 30) // 缩进20px

        // 绘制公司名称
        ctx.textAlign = 'right' // 右对齐
        const company = '福建省海运集团中平船舶管理有限公司'
        ctx.fillText(company, canvas.width - 120, 550)

        // 绘制日期
        const date = formatDate(now)
        ctx.fillText(date, canvas.width - 120, 600)

        // 转换为PNG并下载
        const pngUrl = canvas.toDataURL('image/png')

        // 创建下载链接
        const link = document.createElement('a')
        link.href = pngUrl
        link.download = `学时证明_${userInfo.name || '学员'}_${formatDate(now)}.png`

        // 执行下载
        link.click()

        this.$message.success('PNG学时证明导出成功')
      } catch (error) {
        console.error('PNG导出失败:', error)

        // 如果背景图片加载失败，创建不带背景的图片
        this.createPlainPng(canvas, ctx, userInfo, hour, formatDate, startDate, now)
      }
    },

    // 不带背景的PNG创建函数
    createPlainPng (canvas, ctx, userInfo, hour, formatDate, startDate, now) {
      // 设置画布尺寸
      canvas.width = 800
      canvas.height = 1000

      // 设置背景色
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // 设置字体
      ctx.font = 'bold 36px SimSun, SimHei, Arial, sans-serif'
      ctx.fillStyle = '#000000'
      ctx.textAlign = 'center'

      // 绘制标题
      const title = '学时证明'
      ctx.fillText(title, canvas.width / 2, 80)

      // 设置正文字体
      ctx.font = '24px SimSun, SimHei, Arial, sans-serif'
      ctx.textAlign = 'left'

      // 绘制学员姓名
      const userName = `${userInfo.name || '学员'}：`
      ctx.fillText(userName, 80, 150)

      // 绘制培训详情（缩进两个字符）
      const trainDetails = `  于 ${formatDate(startDate)}——${formatDate(now)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，完成${hour}学时（60分钟/学时），符合要求。`
      this.wrapText(ctx, trainDetails, 100, 200, canvas.width - 160, 30) // 缩进20px

      // 绘制公司名称
      ctx.textAlign = 'right' // 右对齐
      const company = '福建省海运集团中平船舶管理有限公司'
      ctx.fillText(company, canvas.width - 80, 600)

      // 绘制日期
      const date = formatDate(now)
      ctx.fillText(date, canvas.width - 80, 650)

      // 转换为PNG并下载
      const pngUrl = canvas.toDataURL('image/png')

      // 创建下载链接
      const link = document.createElement('a')
      link.href = pngUrl
      link.download = `学时证明_${userInfo.name || '学员'}_${formatDate(now)}.png`

      // 执行下载
      link.click()

      this.$message.success('PNG学时证明导出成功（无背景）')
    },

    // 通过关键词搜索菜单
    searchTrain () {
      if (this.blockClick()) {
        return
      }
      let keyWord = this.keyWord
      if (keyWord === '') {
        this.$message.error('请先输入关键字!')
        return
      }
      this.$router.push({path: '/index/submenu', query: {keyWord: keyWord}})
    },
    getBranchList () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getBranchListFn
      sendData.vm = this
      req.Post('branch/get_branch', sendData)
    },
    getBranchListFn (data) {
      if (data.err_code !== 0) {
        // alert(data.err_msg)
        return
      }
      this.global.branchList = data.list
    },
    getStationList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getStationListFn
      sendData.vm = this
      req.Get('station/get_job', sendData)
    },
    getStationListFn (data) {
      if (data.err_code !== 0) {
        // alert(data.err_msg)
        return
      }
      this.global.stationList = data.list
    },
    // 新用户首次注册查看手册
    blockClick () {
      if (this.$route.path === '/required') {
        this.$message.info('请先阅读完当前手册')
        return true
      }
      return false
    },
    gotoIndex () {
      this.global.model = 1
      let userInfo = this.global.user_info
      if (!userInfo) {
        return
      }
      this.getUserPlayed(userInfo.id) // 获取用户当前已看视频
      this.countTheNumberOfVideos()// 统计用户未看视频
      this.getbooksRead(userInfo.id)
      if (this.blockClick()) {
        return
      }
      if (this.$refs.view.videoState !== undefined && this.$refs.view.videoState) { // 代表视频已经播放完
        this.$confirm('当前视频未播放完成,退出将重新观看！', '学习中', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/index/menuIndex')
          this.keyWord = ''
        }).catch(() => {
        })
        return
      }
      this.$router.push('/index/menuIndex')
      this.keyWord = ''
    },
    getbooksRead (id) {
      let msg = {}
      msg.id = id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getbooksReadfn
      sendData.vm = this
      req.Post('user/getbooksRead', sendData)
    },
    // 重新拉去用户学习记录数据
    getbooksReadfn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      window.$global.user_info.study_record = data.list.study_record
      window.$global.user_info.learn_time = data.list.learn_time
    },
    // 获取用户视频已播放记录
    getUserPlayed (id) {
      let msg = {}
      msg.id = id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getUserPlayedFn
      sendData.vm = this
      req.Post('user/getUserPlayed', sendData)
    },
    getUserPlayedFn (data) {
      if (data.err_code !== 0) {
        return
      }
      // eslint-disable-next-line eqeqeq
      if (data.list == '[]' || data.list == null || data.list == 'null') {
        this.global.videoReadList = []
        return
      }
      let list = []
      let obj = JSON.parse(data.list)
      obj.map((value) => {
        if (value) {
          list.push(value)
        }
      })
      this.global.videoReadList = list
    },
    // 获取视频个数
    countTheNumberOfVideos () {
      let count = this.global.user_info.station_id
      let id = this.global.user_info.id
      let msg = {}
      msg.count = count
      msg.id = id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.countTheNumberOfVideosFn
      sendData.vm = this
      req.Post('user/countTheNumberOfVideos', sendData)
    },
    countTheNumberOfVideosFn (data) {
      if (data == null) {
        return
      }
      this.global.mustLearnVideo = data.list
    },
    // 获取url中"?"符后的字串
    getToken () {
      let url = window.location.href
      let index = url.indexOf('?')
      if (index === -1) {
        window.location.href = this.global.loginURL
      }
      let token = url.substring(index + 1, url.length).replace('#/', '')
      this.global.token = token
      this.getUserData(token)
    },
    getUserData (token) {
      let msg = {}
      msg.token = token
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getUserDatafn
      sendData.vm = this
      req.Post('user/analy_token', sendData)
    },
    getUserDatafn (data) {
      if (data.err_code !== 0) {
        // alert(data.err_msg)
        console.log('错误', data)
        return
      }
      this.getUserPlayed(data.list.id)
      this.getbooksRead(data.list.id)
      let info = data.list
      this.global.videoReadList = (info['played'])
      this.global.user_info = info
      this.global.learn_time = info.learn_time
      this.startHeartBeat()
      // 是否为第一次登陆
      let state = info.is_enter
      this.global.station_id = info.station_id
      this.countTheNumberOfVideos()
      if (this.$route.path === '/index/submenu' || this.$route.name === 'books') {
        return
      }
      if (state) {
        // 带上岗位id
        let stationId = info.station_id
        this.$router.push({path: '/required', query: {stationId: stationId}})
      } else {
        this.$router.push('/index/menuIndex')
      }
    },
    startHeartBeat () {
      this.heartBeat()
      let _this = this
      clearInterval(this.heartTime)
      this.heartTime = setInterval(function () {
        _this.heartBeat()
      }, 10000)
    },
    heartBeat () {
      let sendData = {}
      let msg = {}
      msg.id = this.global.user_info.id
      sendData.data = msg
      sendData.fn = this.setIntCollBack
      sendData.vm = null
      req.Get('user/heart', sendData)
    },
    setIntCollBack (data) {
      if (data === null) {
        // alert('服务器未连接')
        // window.location.href = window.$global.loginURL
        this.$message.error('服务器未连接')
        this.serverUnconnectCount++
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        this.serverUnconnectCount++
        // window.location.href = window.$global.loginURL
      }
    }
  },
  components: {
    certificate
    // index
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

#app {
  min-width: 1200px;
  min-height: 750px;
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}

.goindex {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 2%;
  cursor: pointer;
  font-size: 22px;
}

.head {
  position: fixed;
  width: 100%;
  height: 4%;
  display: flex;
  align-items: center;
  background-color: #404040;
  color: white;
  position: relative;
  top: 0;
}

.logo {
  width: 365px;
  height: 25px;
  background-image: url(./assets/bg/02.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
  margin-left: 100px;
  margin-right: 16px;
}

.indexContent {
  height: 92%;
}

.indexContent {
  /* position: absolute; */
}

/* .bottom{
height: 4%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #404040;
  color: aliceblue;
} */
.bottom {
  height: 4%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #404040;
  color: aliceblue;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.5em;
  border-radius: 50%;
  height: 2em !important;
  line-height: 2em !important;
  margin-top: -1em !important;
  margin-left: -1em !important;
  width: 2em !important;
  outline: none;
  top: 27rem;
  left: 45rem;
}

.head_search {
  width: 20%;
  position: absolute;
  right: 20px;
  height: 90%;
  top: 5px;
}
.exportTime {
  position: absolute;
  top: 5%;
  left: 93%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue